var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isCountryPermitted
    ? _c(
        "div",
        { staticClass: "navbar fmoHeader hidden-xs padding-none clearfix" },
        [
          _c(
            "ul",
            { staticClass: "nav navbar-nav fmoHeader__content float--right" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass:
                    "nav__listItem js-navListItem nav__listItem--level1 nav__listItem--sub"
                },
                [
                  _vm.isCustomerLoggedIn
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "nav__listItemLink nav__listItemLink--level1",
                          attrs: {
                            title: "My Account",
                            href: this.shopUrl + "/customer/account"
                          }
                        },
                        [_vm._v("My Account")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isCustomerLoggedIn
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "nav__listItemLink nav__listItemLink--level1",
                          attrs: {
                            title: "Login",
                            href: this.shopUrl + "/customer/account/login"
                          }
                        },
                        [_vm._v("My Account")]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass:
                    "nav__listItem js-navListItem nav__listItem--level1 nav__listItem--sub nav__listItem__shoppingCart--marginRight"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "nav__listItemLink nav__listItemLink--level1 position-relative",
                      attrs: { href: this.shopUrl + "/checkout/cart" }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/fileadmin/template/img/share/header/cart.png",
                          width: "25px",
                          height: "25px",
                          alt: "shopping cart"
                        }
                      }),
                      _vm._v(" "),
                      _vm.isCustomerLoggedIn && _vm.numberOfItemsInCart
                        ? _c("div", { staticClass: "shoppingCart__blueDot" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.numberOfItemsInCart) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "hidden nav__listItemLink nav__listItemLink--level1 js-shoppingCart shoppingCart",
              attrs: { href: this.shopUrl + "/checkout/cart" }
            },
            [
              _c("img", {
                attrs: {
                  src: "/fileadmin/template/img/share/header/cart.png",
                  width: "25px",
                  height: "25px",
                  alt: "shopping cart"
                }
              }),
              _vm._v(" "),
              _vm.isCustomerLoggedIn && _vm.numberOfItemsInCart
                ? _c("div", { staticClass: "shoppingCart__blueDot" }, [
                    _vm._v(
                      "\n      " + _vm._s(_vm.numberOfItemsInCart) + "\n    "
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "hidden" }, [
            _c("li", { staticClass: "js-navigationShopLinks" }, [
              _vm.isCustomerLoggedIn
                ? _c(
                    "a",
                    {
                      attrs: {
                        title: "My Account",
                        href: this.shopUrl + "/customer/account"
                      }
                    },
                    [_vm._v("My Account (Shop)")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isCustomerLoggedIn
                ? _c(
                    "a",
                    {
                      attrs: {
                        title: "Login",
                        href: this.shopUrl + "/customer/account/login"
                      }
                    },
                    [_vm._v("My Account (Shop)")]
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticClass:
          "nav__listItem js-navListItem nav__listItem--level1 nav__listItem--sub"
      },
      [
        _c(
          "a",
          {
            staticClass: "nav__listItemLink nav__listItemLink--level1",
            attrs: { href: "tel:+18008079166" }
          },
          [_c("i", { staticClass: "fa fa-phone" }), _vm._v("(800) 8079166")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticClass: "hidden-xs nav__listItem",
        staticStyle: { "padding-top": "9px" }
      },
      [
        _c("span", {
          staticStyle: { color: "white", "border-left": "1px solid #fff" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }